<template>
    <div style="margin:50px;">
       <el-input class="area" type="text" placeholder="输入快递单号" v-model.trim="keyword" @input="inputHandler" clearable style="width:300px;">
		</el-input>

        <div>单号：{{keyword}}</div>

        <img src="https://wuji-airport.oss-cn-hangzhou.aliyuncs.com/100k0y000000lzekl0155_C_500_280.jpg"/>
    </div>
</template>
<script>
export default {
    data() {
        return {
          keyword:""
        }
    },
    methods:{
        inputHandler(){
            let that = this;
            if (!that.keyword) return;
          setTimeout(() => {
              console.log(that.keyword)
          }, 200);
        }
    }
}
</script>


// WEBPACK FOOTER //
// demo.vue?566cb3f4